/* TODO: t() */
import React, { Component, ComponentProps } from 'react';
import cx from 'classnames';
import autobind from 'class-autobind';

type ListItemProps = {
  children?: React.ReactNode;
  className?: string;
  name?: string;
};

export class ListItem extends Component<ListItemProps> {
  constructor(props: ListItemProps) {
    super(props);
    autobind(this);
  }

  render() {
    let className = cx('named-list-item', this.props.className);
    return (
      <div className={className}>
        <div className="named-list-name">
          <div className="named-list-name-inner">{this.props.name}</div>
        </div>
        <div className="named-list-value">{this.props.children}</div>
      </div>
    );
  }
}

type NamedListProps = ComponentProps<'div'>;

class NamedList extends Component<NamedListProps> {
  constructor(props: NamedListProps) {
    super(props);
    autobind(this);
  }

  render() {
    return (
      <div {...this.props}>
        <div className="named-list">{this.props.children}</div>
      </div>
    );
  }
}

export default NamedList;
